module.exports = __webpack_public_path__ + "img/MEDIA016.391c09ac.jpg";